module.exports = __webpack_public_path__ + "img/wolf_1248.56401bf8.png";